import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './procrastination.json'; // The JSON you provided

const Procrastination = () => {
  return (
    <div className="topic-page-container">
        {/* We can still use your Layout, but we pass the Router as children or a prop */}
        <TopicsPageLayout
            
            description="Overcome procrastination with productivity vocabulary and grammar practice. B2 level exercises including reading and discussion."
            level="B2"
            title="Procrastination"
            image="/Images/procrastination.webp"
            seoTitle="Free English Lesson Plans: Procrastination"
            seoDescription="Overcome procrastination with productivity vocabulary and grammar practice. B2 level exercises including reading and discussion."
        >
            {/* Map through the JSON and render everything immediately */}
            
                {topicData.map((section, index) => (
                    <div key={index} className="lesson-section-wrapper">
                        <TopicsRouter sectionData={section} />
                    </div>
                    ))}
            
        </TopicsPageLayout>
    </div>
  );
};

export default Procrastination;


